<script setup lang="ts">
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import { CopilotErrorRecoveryEnum } from "~/utils/enums/copilot/errors.enums";
import { getCopilotErrorPresentation } from "~/utils/helpers/copilot/errors";
import type { ICopilotError } from "~/utils/interfaces/copilot-blocks-interfaces";

const props = withDefaults(
  defineProps<{
    error: ICopilotError;
    canRetry?: boolean;
    disabled?: boolean;
  }>(),
  { canRetry: true, disabled: false },
);

const emit = defineEmits<{
  recover: [recovery: CopilotErrorRecoveryEnum];
}>();

const presentation = computed(() => getCopilotErrorPresentation(props.error));
const showAction = computed(
  () => !!presentation.value.actionLabel && (props.error.recovery !== CopilotErrorRecoveryEnum.RETRY || props.canRetry),
);

const actionIcon = computed(() => {
  if (props.error.recovery === CopilotErrorRecoveryEnum.RETRY) return "refresh";
  if (props.error.recovery === CopilotErrorRecoveryEnum.CORRECT_INPUT) return "edit";
  if (props.error.recovery === CopilotErrorRecoveryEnum.ATTACH_PDF) return "attached-document";

  return undefined;
});
</script>

<template>
  <div class="flex flex-col gap-2 items-start">
    <span class="body_regular text-primary-color">{{ presentation.message }}</span>
    <AppButton
      v-if="showAction"
      type="link"
      :label="presentation.actionLabel!"
      :icon="actionIcon"
      :disabled="disabled"
      @click="emit('recover', error.recovery)"
    />
  </div>
</template>
